import { apiClient } from "../api/apiClient";

import {
    ApiResponse,
    Banner,
    CreateBannerRequest,
    UpdateBannerStatusDto
} from "../interfaces/Banner";

// ======================================
// BANNER SERVICE
// ======================================

export const bannerService = {

    // ======================================
    // GET ALL
    // ======================================

    getAll: async (): Promise<Banner[]> => {

        const response =
            await apiClient.get<
                ApiResponse<Banner[]>
            >(
                "/Banners"
            );

        const result =
            response.data;

        console.log(response.data, "dataRes");

        if (!result.isSuccess) {

            throw new Error(  
                result.message
            );
        }

        return result.dataList || [];
    },

    // ======================================
    // GET BY ID
    // ======================================

    getById: async (
        id: number
    ): Promise<Banner> => {

        const response =
            await apiClient.get<
                ApiResponse<Banner>
            >(
                `/Banners/${id}`
            );

        const result =
            response.data;

        if (!result.isSuccess) {

            throw new Error(
                result.message
            );
        }

        return result.data;
    },

    // ======================================
    // CREATE
    // ======================================

    async create(data: CreateBannerRequest) {

        const formData = new FormData();

        formData.append(
            "BannerTitle",
            data.title
        );

        formData.append(
            "BannerSubTitle",
            data.subtitle || ""
        );

        formData.append(
            "ButtonLink",
            data.link || ""
        );

        formData.append(
            "Position",
            data.position
        );

        formData.append(
            "DisplayOrder",
            String(data.order)
        );

        formData.append(
            "StartDate",
            data.startDate || ""
        );

        formData.append(
            "EndDate",
            data.endDate || ""
        );

        formData.append(
            "BannerStatus",
            String(data.status === "active")
        );


        formData.append("TitleEm", data.titleEm || "");
        formData.append("Tag", data.tag || "");
        formData.append("ThumbnailLabel", data.thumbnailLabel || "");

        if (data.thumbnailImage) {
            formData.append("ThumbnailImage", data.thumbnailImage);
        }

        if (data.bannerImage) {

            formData.append(
                "BannerImage",
                data.bannerImage
            );
        }

        console.log(data,"Data Check");

        const response = await apiClient.post(

            "/Banners/Create",

            formData,

            {
                headers: {
                    "Content-Type":
                        "multipart/form-data"
                }
            }
        );

        return response.data;
    }
    ,

    // ======================================
    // UPDATE
    // ======================================

  update: async (payload: FormData) => {
  const formData = new FormData();

  // REQUIRED ID
  formData.append("BannerID", payload.get("bannerID") as string);

  // SAME FIELD NAMES AS CREATE API
  formData.append("BannerTitle", payload.get("title") as string);
  formData.append("BannerSubTitle", payload.get("subtitle") as string);
  formData.append("ButtonLink", payload.get("link") as string);
  formData.append("Position", payload.get("position") as string);

  formData.append("DisplayOrder", payload.get("order") as string);
  formData.append("StartDate", payload.get("startDate") as string);
  formData.append("EndDate", payload.get("endDate") as string);

  formData.append("BannerStatus",
    payload.get("status") === "active" ? "true" : "false"
  );

  formData.append("TitleEm", payload.get("titleEm") as string || "");
  formData.append("Tag", payload.get("tag") as string || "");
  formData.append("ThumbnailLabel", payload.get("thumbnailLabel") as string || "");

  const bannerImage = payload.get("bannerImage");
  if (bannerImage instanceof File) {
    formData.append("BannerImage", bannerImage);
  }

  const thumbnailImage = payload.get("thumbnailImage");
  if (thumbnailImage instanceof File) {
    formData.append("ThumbnailImage", thumbnailImage);
  }

  const response = await apiClient.put(
    "/Banners/Update",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );

  return response.data;
},

    // ======================================
    // DELETE
    // ======================================

    delete: async (
        id: number
    ) => {

        const response =
            await apiClient.delete(
                `/Banners/${id}`
            );

        return response.data;
    },
updateStatus: async (data: UpdateBannerStatusDto) => {
  const response = await apiClient.put(
    "/Banners/UpdateStatus",
    {
      bannerID: data.bannerID,
      bannerStatus: data.status === "active"
    }
  );

  return response.data;
}
};